module.exports = __webpack_public_path__ + "img/quadro.c78dc9d7.svg";